import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const NotificationScheduler = () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const [alertType, setAlertType] = useState("");
  const [timeOfTheDay, setTimeOfTheDay] = useState("");

  const alertShown = useRef(false);

  // Fetch type from query param or API
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const typeFromUrl = queryParams.get("type");
    const timeFromUrl = queryParams.get("_time_of_day");


    if (typeFromUrl) {
      setAlertType(typeFromUrl.toUpperCase());

    }
    if (timeFromUrl) {
      setTimeOfTheDay(timeFromUrl);

    }
    // else {
    //   const fetchNotificationType = async () => {
    //     try {
    //       const response = await axios.get(`${baseUrl}/getNotificationType`);

    //       const apiType = response.data.type;
    //       const apiTimeOfDay = response.data._time_of_day;

    //       if (apiType) {
    //         setAlertType(apiType.toUpperCase());
    //       }

    //       if (apiTimeOfDay) {
    //         setTimeOfTheDay(apiTimeOfDay);
    //       }

    //     } catch (err) {
    //       console.error("API call failed:", err);
    //     }
    //   };
    //   fetchNotificationType();
    // }
  }, [location.search, baseUrl]);

  // Show alert and send notification
  useEffect(() => {

    const sendHomeworkNotification = async () => {
      try {
        // Step 1: Get notifications from /homeworknotification
        console.log(timeOfTheDay);
        console.log(alertType);


        const response = await axios.post(`${baseUrl}/homeworknotification/`, {
          notification_type: alertType,
          time_of_day: timeOfTheDay,
        });


        const notificationList = response.data;

        if (!Array.isArray(notificationList)) {
          console.error("Expected array from /homeworknotification:", notificationList);
          return;
        }

        console.log(" Homework notification response:", notificationList);


        const jobNotificationResponse = await axios.post(
          `${baseUrl}/send/job-notifications/`,
          { data: notificationList }
        );

        console.log("Job notifications sent:", jobNotificationResponse.data);

      } catch (error) {
        console.error(" Notification processing failed:", error);
      }
    };

    if (alertType && !alertShown.current) {
      alertShown.current = true;

      const queryParams = new URLSearchParams(location.search);
      queryParams.set("type", alertType);
      queryParams.set("_time_of_day", timeOfTheDay);
      navigate(
        {
          pathname: location.pathname,
          search: queryParams.toString(),
        },
        { replace: true }
      );



      sendHomeworkNotification();
    }
  }, [alertType, timeOfTheDay, location.pathname, navigate, location.search, baseUrl]);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Notification Scheduler</h2>
      <p>Popup alert will show and notification will be triggered when type is set.</p>
    </div>
  );
};

export default NotificationScheduler;
